import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "badgeList", "pickerInput", "badgeTemplate" ]

  addFromPicker(event) {
    event.preventDefault()

    const select = this.pickerInputTarget
    const assetId = select.value
    if (!assetId) return

    const existing = this.badgeListTarget.querySelectorAll(".js-machinery-asset-id")
    for (const input of existing) {
      if (input.value === assetId) return
    }

    const label = select.options[select.selectedIndex].text
    const html = this.badgeTemplateTarget.innerHTML.trim()

    const wrapper = document.createElement("div")
    wrapper.innerHTML = html
    const badge = wrapper.firstElementChild

    badge.querySelector(".js-machinery-asset-id").value = assetId
    badge.querySelector(".machinery-badge-label").textContent = label

    this.badgeListTarget.appendChild(badge)
    select.selectedIndex = 0
  }

  removeBadge(event) {
    event.preventDefault()
    const badge = event.target.closest("[data-machinery-badge]")
    if (badge) badge.remove()
  }
}
